import { gql } from "@apollo/client";
export const CREATE_TEAM = gql`
  mutation CreateTeam($name: String!, $organizationId: uuid!) {
    insert_team_one(object: { organization_id: $organizationId, name: $name }) {
      id
    }
  }
`;

export const EDIT_TEAM = gql`
  mutation EditTeam($teamId: uuid!, $name: String!) {
    update_team_by_pk(pk_columns: { id: $teamId }, _set: { name: $name }) {
      id
    }
  }
`;

export const DELETE_TEAM = gql`
  mutation DeleteTeam($teamId: uuid!) {
    update_team_by_pk(
      pk_columns: { id: $teamId }
      _set: { deleted_at: "now()" }
    ) {
      id
    }
    delete_person_team(where: { team_id: { _eq: $teamId } }) {
      affected_rows
    }
  }
`;

export const ASSIGN_MEMBERS_TO_TEAM = gql`
  mutation AssignMembersToTeam(
    $teamId: uuid!
    $input: [person_team_insert_input!]!
  ) {
    delete_person_team(where: { team_id: { _eq: $teamId } }) {
      affected_rows
    }

    insert_person_team(objects: $input) {
      affected_rows
    }
  }
`;
